import { Avatar, Button, Checkbox, styled as styledMui } from "@mui/material";
import styled  from "styled-components";



export const ContainerInside = styled.div<any>`
    display: flex;
    flex-direction: ${props => props.fd ? props.fd : "column"};
    margin: ${props => props.m ? props.m : 'none'};
`

export const Items = styled.div`
 display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 5px;

    .MuiFormControl-root {
      margin: 5px 0px;
      
    }
`
export const Column = styled.div<any>`
    display: flex;
    flex-direction: column;
    justify-content: ${p => p.jc ? p.jc : 'center'};
    align-items: ${p => p.ai ? p.ai : 'center'};
    margin: 8px 8px 0px 8px;
    width: 100%;
    max-height: ${p => p.mh ? p.mh : "auto"};
`;

export const ColumnFlex1 = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 15px;
    min-width: 250px;
`;

export const Row = styled.div<any>`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 15px;
    width: ${props => props.wd ? props.wd : "100%"};
    flex: 1;
`;

export const RowForm = styled.div`
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    align-content: center;
`;

export const FormItem = styled.div<any>`
 width: ${props => props.wd ? props.wd : "100%"};
`;


export const BtnContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    margin-top: 20px;
`;
export const BtnOutlined = styled(Button)`
    color: ${(p:any) => p.theme.btn?.primary.background} !important;
    background-color: #FFFF !important;
    border: 2px solid ${(p:any) => p.theme.btn?.primary.background} !important;
    border-top: 0px !important;
    border-left: 0px !important;
    padding: 5px 10px !important; 
    transition: box-shadow 0.3s ease-in-out !important;
    width: fit-content;
    

    &:hover {
        box-shadow: 4px 7px 10px -7px rgba(0,0,0,0.75) !important;
    }
`;
export const BtnFill = styled(Button)`
    color: white !important;
    background-color: ${p => p.theme.secondColor}  !important;
    transition: box-shadow 0.3s ease-in-out !important;
    padding: 5px 10px !important; 
    width: fit-content;

    &:hover {
        box-shadow: 4px 7px 10px -7px rgba(0,0,0,0.75) !important;
    }
`;

export const ItCheckbox = styled(Checkbox)`
    color: ${p => p.theme.secondColor} !important;
`;

export const ItCheckboxOriginal = styled(Checkbox)`
    color: ${p => p.theme.secondColor} !important;
`;


export const ItemContainer = styled.div<any>`
    display: flex;
    flex-direction: ${props => props.column ? "column" : 'row'};
    justify-content: flex-start;
    margin: 10px 0px;
    margin-left: 0;
    font-size: 1rem;
`;
export const LabelItem = styled.div`
    white-space: nowrap;
    font-weight: 600;
    margin-right: 10px;
`;
export const ValueItem = styled.div`
    
    word-break:break-word;
`;
export const ChipContainer = styled.div`
    max-width: 600px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
`;

export const Chip = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    background-color: ${p => p.theme.primaryColor};
    color: white;
    padding: 7px 10px;
    width: fit-content;
    border-radius: 15px;
    margin: 10px;
`

export const ContainerItem = styled.div<any>`
    display: flex;
    flex-direction: row;
    height: ${props => props.hg ? props.hg : "3rem"};
    width: 95%;
`;

export const ContainerDesc = styled.div`
    height: 3rem;
    width: 95%;
    flex-direction: row;
    display: flex;
`;


export const ContainerValue = styled.div`
    height: 3rem;
    width: 95%;
`;

export const Label = styled.label`
    font-size: 28;
`;

export const DivSection = styled.div`
    padding: 20px;
`;


export const ContainerInput = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: ${props => props.jc ? props.jc : "flex-start"};
    width: ${props => props.wd ? props.wd : "100%"};
    margin-right: ${props => props.mr ? props.mr : "15px"};
    margin-bottom:  ${props => props.mb ? props.mb : "10px"};;

    strong{
        word-break:break-word;
    }

    span{
        color:red;
        font-weight:bold;
    }

    
`;

export const ContainerInsideInputs = styled.div<any>`
    display: flex;
    flex-direction: ${props => props.fd ? props.fd : "column"};
    margin-top:${props => props.mt ? props.mt : "0px"};
    margin-right: ${props => props.mr ? props.mr : "15px"};
    width: ${props => props.wd ? props.wd : "100%"};
`;
export const ContainerSection = styled.div`
    margin-top: 20px;
    width: 98%;
    overflow: auto;
    height: 350px;
    background-color: #FFFFFF;
    border-radius: 15;
`;

export const CardContainer = styled.div`
    width: 258px;
    height: 128px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #0000008D;
    border: 1px solid #FFFFFF;
    border-radius: 10px;
    opacity: 1;
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const DivAction = styled.div`
    background: #4B4B4B 0% 0% no-repeat padding-box;
    border: 1px solid #4B4B4B;
    border-radius: 15px;
    opacity: 1;
    width: 90%;
    min-height: 70px;
    margin-top: 10px;
    padding: 15px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Line = styled.hr`
  flex: 1;
  border: none;
  height: 1px;
  background-color: black;
  margin: 0 10px;
`;

export const Title = styled.h3`
  text-align: center;
`;

export const AvatarStyle = styled(Avatar)`
    height: 56px !important;
    width: 56px !important;
    background-color: ${p => p.theme.secondColor} !important;
`

export const CmbWithTitle = styled.div<any>`
    display: flex;
    justify-content: flex-start;
    align-items: ${p => p.aI ? p.aI : "baseline"};
    margin: 0px 8px 0px 8px;
    width: ${p => p.fullWidth ? "100%" : "fit-content"}; 
    font-size: 0.8rem;
    font-weight: bold;
    max-width: 100%;
    

    span{
        margin-right:5px;
        text-wrap: nowrap;
        font-size: 1.1rem;
        font-weight: 500;
        color: ${p => p.error ? '#e43d3d' : '#2c2c2c' };
    }
`;